'use strict';

angular.module('searchModule')

.controller('SearchActionsSolrController', ['$state', '$scope', '$location', '$sce', 'searchService', 'historyCtxtService', function ($state, $scope, $location, $sce, searchService, historyCtxtService) {


    const SEARCHACTIONTYPE_BROWSE = 1;
    const SEARCHACTIONTYPE_NEW = 2;
    const SEARCHACTIONTYPE_EXPORT = 3;

    // Get configuration
    searchService.getConfiguration()
        .then(function (conf) {

            //var ctxSearchActions = conf.ItemSearchActions;
            //var map = {};
            //var action;
            //var roots = [];

            //if (ctxSearchActions.length > 0) {
            //// Create tree based on search action items
            //    for (var i = 0; i < ctxSearchActions.length; i += 1) {
            //        action = ctxSearchActions[i];
            //        action.children = [];
            //        map[action.ItemSearchActionID] = i;
            //        if (action.ParentItemSearchActionID) {
            //            ctxSearchActions[map[action.ParentItemSearchActionID]].children.push(action)
            //        } else {
            //            roots.push(action);
            //        }
            //    }
            //}
            //var newArray = _.filter(ctxSearchActions, function (action) { return (!action.ParentItemSearchActionID); });

            $scope.ctxSearchActions = conf.ItemSearchActions;
            return true;
        });

    // Return array of actions
    $scope.getSearchActionLinks = function (actionName) {

        var actionType = _.find($scope.ctxSearchActions, { TitleEN: actionName });
        if (actionType) {
            return actionType.children;
        }
        else {
            return null;
        }
    }

    $scope.itemSearchAction = function (action) {
        
        $scope.searchCtx.isLeftBarOpen = false;
        if (action.SearchActionType === SEARCHACTIONTYPE_BROWSE) {
        	var sf = [];
			if (action.SelectedFacets) {
				sf = action.SelectedFacets.split('|');
			}
            historyCtxtService.goToState('advancedSearch',
	            {
	            	sourceType: action.Code,
	            	q: '',
					sf: sf
	            });
        }
        else if (action.SearchActionType === SEARCHACTIONTYPE_NEW) {
            $location.url(action.ActionHtml);
        }

    }
    // Return the description of the actionType
    $scope.searchActionDescription = function (actionName) {
        var actionIcon = _.find(searchSourcesConfig, { title: actionName });
        if (actionIcon) {
            return actionIcon.Description;
        }
        else return null;
    }

    // Execute the click of the action
    $scope.executeAction = function (action) {

        var typeRegex = /^(type=[aA-zZ]+) ?(.*)/;
        // $1             $2

        if (typeRegex.test($scope.searchCtx.q)) {
            $scope.searchCtx.q = $scope.searchCtx.q.replace(typeRegex, action.FilteredSearch + ' $2');
        } else {
            $scope.searchCtx.q = action.FilteredSearch + ' ' + ($scope.searchCtx.q || '');
        }

        $scope.search($scope.searchCtx.q);
    };

    // Return if the search type is active
    $scope.isSearchTypeActive = function (action) {
        if (!$scope.searchCtx.q) return false;

        return $scope.searchCtx.q.indexOf(action.FilteredSearch) === 0;
    };

    // Return the UI look of the action
    $scope.displayActionHtml = function (action) {
        return $sce.trustAsHtml(action.ActionHtml);
    }
}]);